/**
 * In-text citation linking: find author-year citation spans in plain text and resolve each
 * cited work against a CSL reference list on evidence alone; find numeric citation spans
 * (`[1]`, `(1)`, `¹`) and resolve them against a numbered bibliography. Pure functions over
 * strings; runs in a browser or in Node.
 *
 * Footnotes: a footnote body is text — author-year citations inside it are found like any
 * other. Lifting a footnote marker into a citation of the note's content needs the document
 * model and is out of scope for this library.
 */
export * from './types';
export { PARTICLE_WORDS, normalizeToken } from './normalize';
export { indexReferences } from './index-references';
export { findCitationSpans, CONNECTOR_WORDS } from './find-spans';
export { resolveConstituent } from './resolve';
export { linkText, LINK_STYLES } from './link-text';
export type { LinkStyle, LinkOptions } from './link-text';
export * from './numeric';
